import React from 'react';

export function useItemSeperator(items: any, filter: string[]) {
  const fxn = (items: any, filter: string[]) => {
    const crossoutItems: any = [];
    const nonCrossOutItems: any = [];
    const tempCrossoutItems: any = [];

    if (Array.isArray(items)) {
      items.forEach((i) => {
        if (!filter.length || filter.includes(i?.customAttributes?.source)) {
          // add items to tempCrossout (temporary cached) items if tempCrossout is not defined and there are exising crossout items in the list
          // if the tempCrossout if defined ('crossout' or '' empty) then either add or remove from the tempCrossout items
          if (
            typeof i?.customAttributes?.tempCrossout === 'undefined' &&
            i?.customAttributes?.crossout === 'crossout'
          ) {
            tempCrossoutItems.push(i);
          } else if (typeof i?.customAttributes?.tempCrossout !== 'undefined') {
            if (i?.customAttributes?.tempCrossout) {
              tempCrossoutItems.push(i);
            } else {
              let index = tempCrossoutItems.findIndex((x) => x.itemId === i.itemId);
              if (index !== -1) tempCrossoutItems.splice(index, 1);
            }
          }
          // seperate all items into crossout and non crossout irrespective of tempCrossout
          if (i?.customAttributes?.crossout === 'crossout') {
            crossoutItems.push(i);
          } else {
            nonCrossOutItems.push(i);
          }
        }
      });
    }

    return [crossoutItems, nonCrossOutItems, tempCrossoutItems];
  };

  return React.useMemo(() => {
    return fxn(items, filter);
  }, [items, filter]);
}

export const generateNewItem = (itemName: string) => {
  let itemDetails = {
    itemName: itemName,
    itemQuantity: 1,
    itemSize: '',
    itemValue: '',
    customAttributes: { crossout: '', source: 'ITEM' }
  };
  return itemDetails;
};
